import React, { createContext, useContext, useState, useEffect } from "react";
import { en } from "../translations/en";
import { ar } from "../translations/ar";
import { fr } from "../translations/fr";

const LanguageContext = createContext();

const translations = {
  en,
  ar,
  fr,
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en");
  const [isRTL, setIsRTL] = useState(false);

  useEffect(() => {
    // Load saved language preference
    const savedLanguage = localStorage.getItem("portfolio-language") || "en";
    setLanguage(savedLanguage);
    setIsRTL(savedLanguage === "ar");

    // Update document direction
    document.documentElement.dir = savedLanguage === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = savedLanguage;
  }, []);

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    setIsRTL(newLanguage === "ar");
    localStorage.setItem("portfolio-language", newLanguage);

    // Update document direction and language
    document.documentElement.dir = newLanguage === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = newLanguage;
  };

  const value = {
    language,
    isRTL,
    changeLanguage,
    translations: translations[language],
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
